import { Component, Input } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { DishServices } from '../../../../dish/services';
import { Globals } from '../../../../../globals';
import { MenuServices } from '../../../../menu/services';

/**
 * Generated class for the ComboPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-complements-partial-section-name',
    templateUrl: 'complements-partial-section-name.html',
})
export class ComplementsPartialSectionNamePage {

    @Input() section;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public globals: Globals,
        public translate: TranslateService,
        public menuServices: MenuServices) {
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/complements/complements-partial-select/complements-create-dish-select/complements-partial-section-name/complements-partial-section-name.ts